import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState = ({
  icon,
  title,
  description,
  actionText,
  actionLink,
  actionClassName
}) => {
  return (
    <div className="text-center py-16">
      <div className="card-glass p-12 max-w-md mx-auto">
        {icon && (
          <div className="mb-6">
            {icon}
          </div>
        )}
        <h2 className="text-3xl font-display font-bold text-gray-900 mb-4">{title}</h2>
        {description && (
          <p className="text-gray-600 text-lg mb-8">{description}</p>
        )}
        {actionText && actionLink && (
          <Link to={actionLink} className={actionClassName || "btn-primary"}>
            {actionText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default EmptyState;

